import { useContext, useEffect, useState } from "react";
import { tokenContext } from '../componentes/TokenContext';
import axios from 'axios';

export const usePayments = () => {

	const { token } = useContext(tokenContext);

	const [consultaPay, setConsultaPay] = useState({
		loadpay: false,
		respuestaPayToken: null
	});

	const getTakito = () => {  
    const rumpelstinki =  {
         "urombrett": "pibe4353fdas",
         "contwyerr": "engyr533hrr5"
       }
   
     let result = axios.post(`/ohaurlisrp/nteragyuytil/`, rumpelstinki)
     .then(response => {
         return response.data;
         })
         .catch((error) => {
            
             return error.response;
         });
          //console.log('topuptkServices: ', result);
         return result;
 }


	const getDataToken = async() =>{
    const tk = await getTakito();
    const request = {
        "method": "GET",
        "path": `/payment/bitacora?token=${token}`
    }
    const config = {
        headers: { Authorization: `Bearer ${tk}` }
    };
   // console.log('cual es el token: ', request );
  axios.post(`/webservice/goapimicrositio`, request, config)
    .then(response => {
        setConsultaPay({
            loadpay:true,
            respuestaPayToken: response
        });
        //console.log('bitacora_token: ', consultaPay );
    })
    .catch((error) => {
        //console.log('error1: ', error);
        setConsultaPay({
            loadpay:true,
            error:{ errorMessage: error.message },
            respuestaPayToken: null,
        });
    });
    return consultaPay;
    
};

	useEffect(() => {
		getDataToken();

	}, [token]);

	return {
		consultaPay
	}
}
